/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { LinkWrapper } from '~/components/Product/Page/LinkWrapper'

export const CategoryCarouselItem = ({ item }) => {
  const { name, slug, images, mainImage, __typename } = item

  const imageFluid = (images?.[0] ?? mainImage).gatsbyImageData
  const imageWidth = __typename === 'ContentfulPage' ? '100%' : '80%'

  return (
    <div
      sx={{
        flexShrink: 0,
        width: 'calc(100% / 5.3)',
      }}
    >
      <LinkWrapper slug={slug} contenttype={__typename}>
        <div
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: '600',
            gap: '10px',
          }}
        >
          <div
            sx={t => ({
              borderRadius: '50%',
              backgroundColor: t.colors.electricViolet,
              width: '66px',
              height: '66px',
              padding: '3px',
              marginTop: '3px',
            })}
          >
            <span
              sx={{
                display: 'flex',
                height: '100%',
                width: '100%',
                backgroundColor: '#ffdd00',
                borderRadius: '50%',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
              }}
            >
              {imageFluid && (
                <GatsbyImage
                  alt=""
                  image={imageFluid}
                  style={{
                    height: imageWidth,
                    width: imageWidth,
                    borderRadius: '50%',
                    overflow: 'unset',
                  }}
                  objectFit="contain"
                />
              )}
            </span>
          </div>
          <span
            sx={t => ({
              color: t.colors.secondary,
              lineHeight: '15px',
            })}
          >
            {name}
          </span>
        </div>
      </LinkWrapper>
    </div>
  )
}
